import React from 'react';
import { CTAButton, SectionHeading, PlaceholderImage } from './ui';
import { Star, Shield, Lock, CreditCard, CheckCircle2, XCircle, BookOpen, Gift } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100svh] flex flex-col justify-center pt-6 pb-6 md:pt-28 md:pb-24 overflow-hidden bg-gradient-to-b from-purple-50 to-white" data-id="element-165">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center w-full" data-id="element-166">
        <div className="inline-block mb-3 md:mb-4 px-3 py-1 md:px-4 md:py-1.5 rounded-full bg-purple-100 text-purple-800 font-semibold text-xs md:text-sm uppercase tracking-wider" data-id="element-167">
          MÉTODO V-GLOW
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-3 md:mb-6 leading-tight" data-id="element-168">
          Todo lo que necesitás para tu bienestar íntimo{' '}
          <span className="text-purple-600" data-id="element-169">resuelto de una vez.</span>
        </h1>

        <div className="max-w-4xl mx-auto mb-3 md:mb-8 mt-1 md:mt-2" data-id="element-170">
          <img src="https://cdn.magicpatterns.com/uploads/647CebrLsV6KvCJMZCXy11/creativos_ebook_profelisto_(9).png" alt="Megapack Método V-Glow — Elite Bundle con los 12 Tomos, 6 Bonus y 2 Ebooks Élite" width={1080} height={1350} fetchPriority="high" decoding="async" className="mx-auto w-auto h-[19rem] sm:h-[27rem] md:h-[38rem] lg:h-[46rem] max-w-full object-contain drop-shadow-2xl" data-id="element-171" />
        </div>

        <p className="text-sm sm:text-base md:text-2xl text-gray-600 mb-4 md:mb-8 max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-172">
          Megapack V-GLOW — La colección completa de bienestar íntimo femenino
          para la mujer argentina que ya probó todo y quiere resultados reales
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-xs md:text-sm font-medium text-gray-700 mb-4 md:mb-10" data-id="element-173">
          <span className="flex items-center gap-1.5 bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-174">
            <span className="text-base md:text-xl" data-id="element-175">📄</span> PDF
          </span>
          <span className="flex items-center gap-1.5 bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-176">
            <span className="text-base md:text-xl" data-id="element-177">⚡</span> Acceso Inmediato
          </span>
          <span className="flex items-center gap-1.5 bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-178">
            <span className="text-base md:text-xl" data-id="element-179">📚</span> 12 Tomos + 6 Bonus
            + 2 Élite
          </span>
        </div>

        <CTAButton className="text-base md:text-xl px-8 py-4 md:px-10 md:py-5 mb-4 md:mb-6" data-id="element-180">
          💜 QUIERO MI MÉTODO V-GLOW AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm text-gray-500 font-medium" data-id="element-181">
          <span className="flex items-center gap-2" data-id="element-182">
            <Shield className="w-4 h-4 text-purple-500" data-id="element-183" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-184">
            <Lock className="w-4 h-4 text-purple-500" data-id="element-185" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-186">
            <CreditCard className="w-4 h-4 text-purple-500" data-id="element-187" /> Tarjetas y
            transferencia
          </span>
        </div>
      </div>
    </section>;
}
export function SocialProof() {
  return <section className="py-12 bg-white border-y border-gray-100" data-id="element-188">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center mb-16 divide-x divide-gray-100" data-id="element-190">
          <div data-id="element-191">
            <div className="text-3xl font-bold text-purple-600 mb-1" data-id="element-192">+800</div>
            <div className="text-sm text-gray-500 font-medium uppercase tracking-wide" data-id="element-193">
              mujeres lo usan
            </div>
          </div>
          <div data-id="element-194">
            <div className="text-3xl font-bold text-purple-600 mb-1" data-id="element-195">
              12 + 6
            </div>
            <div className="text-sm text-gray-500 font-medium uppercase tracking-wide" data-id="element-196">
              Tomos + Bonus
            </div>
          </div>
          <div data-id="element-197">
            <div className="text-3xl font-bold text-purple-600 mb-1" data-id="element-198">4.9/5</div>
            <div className="text-sm text-gray-500 font-medium uppercase tracking-wide" data-id="element-199">
              calificación
            </div>
          </div>
          <div data-id="element-200">
            <div className="text-3xl font-bold text-purple-600 mb-1" data-id="element-201">🇦🇷</div>
            <div className="text-sm text-gray-500 font-medium uppercase tracking-wide" data-id="element-202">
              Argentina
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-203">
          {[{
          initials: 'MP',
          quote: 'Llevaba 3 años con infecciones recurrentes. Con el Tomo 6 del Método V-Glow entendí por qué y cómo cortarlo de raíz. Nunca más volví a la farmacia con vergüenza.',
          name: 'María P., Buenos Aires',
          role: 'Ama de casa y mamá de 2'
        }, {
          initials: 'CG',
          quote: 'Lo del oscurecimiento me daba tanta vergüenza que no lo hablaba con nadie. El Tomo 2 me lo resolvió en 3 semanas con ingredientes que tenía en casa.',
          name: 'Claudia G., Córdoba',
          role: 'Profesora particular'
        }, {
          initials: 'SR',
          quote: 'Antes evitaba la intimidad por miedo al día siguiente. Ahora tengo el protocolo listo y esa ansiedad desapareció completamente.',
          name: 'Sofía R., Rosario',
          role: 'Diseñadora freelance'
        }].map((t, i) => <div key={i} className="bg-purple-50 rounded-2xl p-6 relative" data-id="element-204">
              <div className="flex gap-1 mb-4" data-id="element-205">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-206" />)}
              </div>
              <p className="text-gray-700 italic mb-6" data-id="element-207">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-208">
                <div className="w-10 h-10 rounded-full bg-purple-200 text-purple-700 flex items-center justify-center font-bold text-sm" data-id="element-209">
                  {t.initials}
                </div>
                <div data-id="element-210">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-211">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-212">{t.role}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function PainPoints() {
  const pains = ['Gastás una fortuna en óvulos de farmacia y a los 3 días el ardor vuelve como si nada', 'Tu zona íntima se oscureció y no sabés si es normal o si podés hacer algo', 'Tenés un olor que no es infección declarada pero que te genera ansiedad todo el día', 'Evitás los encuentros íntimos porque te da miedo cómo vas a amanecer al día siguiente', 'La piel está áspera, con pelitos encarnados o irritada después de cada depilación', 'Sabés que algo no está bien pero el ginecólogo te dice que todo está normal', 'Probaste remedios caseros de internet que no funcionaron o que te irritaron más', 'Te da vergüenza hablar de esto con alguien, incluso con tu médica'];
  return <section className="py-20 bg-gray-50" data-id="element-213">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <SectionHeading subtitle="Si sos mujer argentina, esto te va a sonar conocido:" data-id="element-215">
          ¿Te pasa esto?
        </SectionHeading>

        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12" data-id="element-216">
          <ul className="space-y-6" data-id="element-217">
            {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-218">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-219" />
                <span className="text-lg text-gray-700" data-id="element-220">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-221">
          <p className="text-2xl font-bold text-gray-900 mb-8 italic" data-id="element-222">
            "¿Cuánto tiempo más vas a lidiar con esto en silencio?"
          </p>
          <CTAButton variant="secondary" className="text-xl" data-id="element-223">
            👉 BASTA — QUIERO MI MÉTODO V-GLOW AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}
export function ProductIntro() {
  return <section className="py-20 bg-purple-900 text-white" data-id="element-224">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-225">
        <div className="inline-flex items-center gap-2 bg-purple-800/50 px-4 py-2 rounded-full text-purple-200 font-medium mb-8 border border-purple-700" data-id="element-226">
          <span data-id="element-227">🏆</span> El Sistema N°1 de Bienestar Íntimo Femenino en
          Argentina
        </div>

        <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-228">
          MÉTODO V-GLOW — Colección Completa
        </h2>
        <p className="text-2xl text-purple-200 mb-12" data-id="element-229">
          12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todos los problemas.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-230">
          {[{
          label: '+240 páginas',
          icon: '📄'
        }, {
          label: '+80 protocolos',
          icon: '📋'
        }, {
          label: 'Todos los dolores',
          icon: '🎯'
        }, {
          label: 'Adaptado a Argentina',
          icon: '🇦🇷'
        }].map((stat, i) => <div key={i} className="bg-purple-800/40 rounded-xl p-6 border border-purple-700/50" data-id="element-231">
              <div className="text-3xl mb-2" data-id="element-232">{stat.icon}</div>
              <div className="font-semibold" data-id="element-233">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function Tomes() {
  const tomes = [{
    num: 1,
    icon: '🌊',
    title: 'El Reset de Humedad',
    desc: 'El equilibrio del pH íntimo desde cero. Limpieza, hidratación y ecosistema protegido.'
  }, {
    num: 2,
    icon: '✨',
    title: 'Efecto Porcelana',
    desc: 'El protocolo completo para aclarar el oscurecimiento íntimo con ingredientes naturales.'
  }, {
    num: 3,
    icon: '🪡',
    title: 'Zona de Seda',
    desc: 'Cómo eliminar los pelitos encarnados, la foliculitis y recuperar la suavidad real.'
  }, {
    num: 4,
    icon: '🌸',
    title: 'Escudo de Flora',
    desc: 'Construí una barrera protectora de lactobacillus que dure todo el mes.'
  }, {
    num: 5,
    icon: '🍃',
    title: 'Detox Íntimo',
    desc: 'Limpieza profunda de residuos de medicamentos, espermicidas y químicos acumulados.'
  }, {
    num: 6,
    icon: '🧬',
    title: 'Bio-Hacking Anti-Cándida',
    desc: 'El protocolo sistémico para cortar el ciclo de recurrencia desde la raíz.'
  }, {
    num: 7,
    icon: '⚡',
    title: 'Protocolo Post-Encuentro',
    desc: 'Las 20 primeras horas después de la intimidad. Cómo proteger el ecosistema siempre.'
  }, {
    num: 8,
    icon: '🥗',
    title: 'Nutrición del Ecosistema',
    desc: 'Los alimentos que protegen tu flora y los que alimentan al hongo sin que lo sepas.'
  }, {
    num: 9,
    icon: '👗',
    title: 'La Ropa Interior Correcta',
    desc: 'Cómo el textil que usás puede ser la causa de todos tus problemas íntimos.'
  }, {
    num: 10,
    icon: '🌙',
    title: 'El Ritual Nocturno',
    desc: 'La rutina de 10 minutos antes de dormir que regenera tu ecosistema mientras descansás.'
  }, {
    num: 11,
    icon: '💪',
    title: 'Firmeza y Turgencia',
    desc: 'Cómo recuperar el tono, la elasticidad y el volumen de la zona íntima externa.'
  }, {
    num: 12,
    icon: '🆘',
    title: 'Botiquín SOS',
    desc: 'El protocolo de emergencia para los primeros síntomas antes de que se conviertan en infección.'
  }];
  return <section className="py-20 bg-white" data-id="element-234">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <SectionHeading subtitle="Protocolos paso a paso · Por problema y objetivo · Listo para aplicar esta noche" data-id="element-236">
          Los 12 Tomos Completos
        </SectionHeading>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-237">
          {tomes.map(tome => <div key={tome.num} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-238">
              <div className="flex items-center gap-3 mb-4" data-id="element-239">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center text-2xl" data-id="element-240">
                  {tome.icon}
                </div>
                <div data-id="element-241">
                  <div className="text-xs font-bold text-purple-600 uppercase tracking-wider" data-id="element-242">
                    Tomo {tome.num}
                  </div>
                  <h3 className="font-bold text-gray-900 leading-tight" data-id="element-243">
                    {tome.title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-244">
                {tome.desc}
              </p>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-700 bg-purple-50 py-6 rounded-2xl" data-id="element-245">
          <span className="flex items-center gap-2" data-id="element-246">
            <span className="text-xl" data-id="element-247">✏️</span> Protocolos graficados en cada
            tomo
          </span>
          <span className="flex items-center gap-2" data-id="element-248">
            <span className="text-xl" data-id="element-249">⚡</span> Sistema "Leés y Aplicás"
          </span>
          <span className="flex items-center gap-2" data-id="element-250">
            <span className="text-xl" data-id="element-251">📋</span> Recetas listas para preparar en
            casa
          </span>
          <span className="flex items-center gap-2" data-id="element-252">
            <span className="text-xl" data-id="element-253">🇦🇷</span> Ingredientes disponibles en
            Argentina
          </span>
        </div>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    num: 1,
    icon: '🧴',
    title: 'El Recetario V-Glow',
    desc: 'Todas las recetas de serums, soluciones y compresas del Método en un solo lugar. Con ingredientes, dosis y paso a paso.'
  }, {
    num: 2,
    icon: '📓',
    title: 'Mi Diario V-Glow',
    desc: 'Tu planilla de seguimiento semanal. Registrá síntomas, fases del ciclo y resultados para entender los patrones de tu ecosistema.'
  }, {
    num: 3,
    icon: '🛒',
    title: 'V-Glow Shopping Guide',
    desc: 'Dónde comprar cada ingrediente en Argentina. Marcas recomendadas, precios aproximados y qué evitar en cada góndola.'
  }, {
    num: 4,
    icon: '🧘',
    title: 'V-Glow Flow',
    desc: '6 posturas de yoga y movimiento específicamente seleccionadas para mejorar la circulación pélvica y el equilibrio hormonal.'
  }, {
    num: 5,
    icon: '🛡️',
    title: 'V-Glow Safe Sex',
    desc: 'Guía completa de preservativos, lubricantes y materiales compatibles con tu ecosistema. Protegé tu flora antes, durante y después.'
  }, {
    num: 6,
    icon: '🌿',
    title: 'V-Glow Seasons',
    desc: 'Cómo adaptar tu protocolo a cada estación del año. Playa, invierno, viajes y el Reboot Post-Menstruación mensual.'
  }];
  const covers = [{
    bg: 'bg-purple-600',
    spine: 'bg-purple-800'
  }, {
    bg: 'bg-purple-800',
    spine: 'bg-purple-950'
  }, {
    bg: 'bg-fuchsia-700',
    spine: 'bg-fuchsia-900'
  }, {
    bg: 'bg-violet-600',
    spine: 'bg-violet-800'
  }, {
    bg: 'bg-rose-600',
    spine: 'bg-rose-800'
  }, {
    bg: 'bg-indigo-600',
    spine: 'bg-indigo-800'
  }];
  return <section className="py-20 bg-stone-50" data-id="element-254">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="text-center mb-14" data-id="element-256">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight mb-4" data-id="element-257">
            + 6 Bonus Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-gray-500 mb-8" data-id="element-258">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-amber-600 text-white px-6 py-3 rounded-full font-bold text-lg md:text-xl shadow-lg shadow-amber-600/20" data-id="element-259">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-260">
          {bonuses.map((bonus, i) => <div key={bonus.num} className="bg-white rounded-3xl shadow-sm hover:shadow-xl transition-shadow border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-261">
              {/* Book cover mockup */}
              <div className="relative mb-6" data-id="element-262">
                <div className={`relative w-40 h-56 rounded-lg ${covers[i % covers.length].bg} shadow-2xl overflow-hidden flex flex-col justify-between p-5`} data-id="element-263">
                  <div className={`absolute left-0 top-0 h-full w-3 ${covers[i % covers.length].spine}`} data-id="element-264" />
                  <div className="text-3xl drop-shadow-sm" data-id="element-265">{bonus.icon}</div>
                  <div data-id="element-266">
                    <div className="text-white font-extrabold text-xl leading-tight mb-3" data-id="element-267">
                      Bonus {bonus.num}
                    </div>
                    <div className="h-px w-12 bg-white/40 mb-3" data-id="element-268" />
                    <div className="text-white/70 font-semibold text-[11px] tracking-widest uppercase" data-id="element-269">
                      Método V-Glow™
                    </div>
                  </div>
                </div>
              </div>

              <span className="inline-block bg-green-100 text-green-700 font-bold text-sm px-4 py-1.5 rounded-full mb-5" data-id="element-270">
                GRATIS
              </span>

              <h3 className="font-bold text-xl text-gray-900 mb-3 leading-snug" data-id="element-271">
                {bonus.icon} {bonus.title}
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-272">{bonus.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}